import moment from "moment-timezone";
import Selected from "../../formability/organization_management/store/modules/selected";

export default {
  filters: {
    date(datetime) {
      if (datetime) {
        return moment(datetime).tz(Selected.organization.get()?.time_zone || 'America/New_York').format("MMM Do, YYYY");
      } else {
        return null;
      }
    },
    datetime(datetime) {
      if (datetime) {
        return moment(datetime).tz(Selected.organization.get()?.time_zone || 'America/New_York').format("MMM Do, YYYY [at] h:mm a");
      } else {
        return null;
      }
    }
  }
};
